import React from 'react';
import { BeatLoader } from 'react-spinners';

import { Flex } from '../atom/Layout';
import { Text } from '../atom/Text';
import { EmptyMessage } from './EmptyMessage';

import ThemeStyle from '../../../lib/style/ThemeStyle';

const Loading = ({ onlyLoader = false, padding = '1.25rem 1.25rem 0' }) => {
  return (
    <Flex padding={padding} column>
      {!onlyLoader ? (
        <EmptyMessage
          messageList={[
            TEXT_WAIT,
            <BeatLoader color={ThemeStyle.color.orangePink} />,
          ]}
        />
      ) : (
        <>
          <BeatLoader color={ThemeStyle.color.orangePink} />
          <Text
            size={14}
            style={{ display: 'block' }}
            textAlign="center"
            lineHeight="1.25rem"
          >
            {TEXT_WAIT}
          </Text>
        </>
      )}
    </Flex>
  );
};

export default Loading;

const TEXT_WAIT = '잠시만 기다려주세요.';
